<div class="layer-selection__modal">
  <ts-page [sidenavConfig]="{ title: 'Layers' }">
    <div sidenav class="flex flex-col items-start justify-center">
      <div class="layer-selection__categories w-full" *ngFor="let layer of layerCategories; let i = index">
        <button
          class="layer-selection__nav-item"
          [ngClass]="{ 'bg-black-200 cursor-default': activeOptionIndex === i }"
          (click)="activeOptionIndex = i"
        >
          <div class="flex flex-row justify-start items-center gap-1">
            <ts-icon class="w-auto" [icon]="staticLayersMeta[layer.category]?.icon || 'ts_layer-group'"></ts-icon>
            <span>{{ layer.category | titlecase }}</span>
          </div>

          <ng-container *ngIf="layersForm.at(i) | isFormControl; else multiselectCounter">
            <ts-badge *ngIf="layersForm.at(i).value != null" type="transparent" value="1"></ts-badge>
          </ng-container>

          <ng-template #multiselectCounter>
            <ts-badge
              *ngIf="(layersForm.at(i).value | countTrueFromObject) !== '0'"
              type="transparent"
              [value]="layersForm.at(i).value | countTrueFromObject"
            ></ts-badge>
          </ng-template>
        </button>
      </div>
    </div>
    <div main class="layer-selection__main px-3 pt-3 pb-5">
      <div class="layer-selection__header mb-6">
        <p class="text-xl font-bold">{{ activeLayer.category | titlecase }}</p>
        <p class="text-black-500" *ngIf="staticLayersMeta[activeLayer.category]?.description as description">
          {{ description }}
        </p>
      </div>

      <div class="layer-selection__form">
        <ng-container *ngIf="activeLayerForm | isFormControl; else multipleSelection">
          <mat-radio-group [selected]="null" class="flex flex-col gap-1" [formControl]="activeLayerForm">
            <mat-radio-button [value]="null" color="primary">None</mat-radio-button>
            <mat-radio-button
              *ngFor="let option of activeLayer.layers"
              [value]="option.id"
              [disabled]="!option.active"
              [color]="'primary'"
            >
              {{ option.label }}
            </mat-radio-button>
          </mat-radio-group>
        </ng-container>

        <ng-template #multipleSelection>
          <form class="flex flex-col gap-1" [formGroup]="activeLayerForm">
            <mat-checkbox
              *ngFor="let option of activeLayer.layers"
              [formControlName]="option.id"
              [disabled]="!option.active"
              [color]="'primary'"
            >
              {{ option.label }}
            </mat-checkbox>
          </form>
        </ng-template>
      </div>
    </div>
  </ts-page>
</div>
